const { hostname } = window.location;
const isLocal = hostname === 'localhost';

const awsAmplify = {
  Auth: {
    identityPoolId: process.env.VUE_APP_IDENTITY_POOL_ID,
    region: process.env.VUE_APP_REGION,
    userPoolId: process.env.VUE_APP_USER_POOL_ID,
    userPoolWebClientId: process.env.VUE_APP_USER_POOL_WEB_CLIENT_ID,
    mandatorySignIn: true,
    cookieStorage: {
      domain: isLocal ? 'localhost' : process.env.VUE_APP_DOMAIN,
      path: '/',
      expires: 365,
      sameSite: 'lax',
      secure: !isLocal,
    },
  },
};
export default awsAmplify;
